<template>
  <div class="instInputWrap">
    <div class="instCheckBoxFlexWrap"  v-bind:style="{'align-items':alignItems}">
      <div class="instCheckBoxWrap">
        <input type="checkbox" v-model="value" :true-value="item.values.trueValue.value" :false-value="item.values.falseValue.value">
        <svg viewBox="0 0 37 23" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:style="{fill:calcFill}" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11.504.43C12.767.359 14.027.365 15.29.365h6.396c1.287 0 2.548-.006 3.81.067 1.147.065 2.264.205 3.376.517a11.075 11.075 0 015.864 3.968 11.098 11.098 0 010 13.44 11.08 11.08 0 01-5.864 3.97c-1.112.311-2.23.45-3.376.516-1.262.073-2.523.067-3.785.067h-6.398c-1.286 0-2.546.006-3.809-.067-1.146-.066-2.263-.205-3.376-.517A11.08 11.08 0 010 11.637a11.1 11.1 0 012.265-6.72A11.076 11.076 0 018.128.946c1.113-.311 2.23-.45 3.376-.516z"/></svg>
        <div class="instCheckBoxMarker" v-bind:class="{trueValue: value === item.values.trueValue.value}"></div>
      </div>
      <div class="layoutBody" v-if="isContent">
        <slot name=content></slot>
      </div>
      <p v-html="item.label" v-else></p>
    </div>
    <p class="instErrMsg" v-if="fieldStatus.ShowError">{{ fieldStatus.msg }}</p>
  </div>
</template>

<script>
import DataForInput from "@/store/Form/longFormOptions";
import {mapState} from "vuex";

export default {
  name: "instCheckBox",
  data(){
    return {
      item: DataForInput[this.fieldName],
    }
  },
  props:{
    alignItems:{
      type:String,
      default() {
        return 'flex-start'
      }
    },
    fieldName: {
      type: String,
      default: ''
    },
  },
  computed:{
    isContent() {
      return this.$slots['content'];
    },
    ...mapState({
      statusVuex: state => state.Form.workData,
      valueVuex: state => state.Form.sendData,
    }),
    fieldStatus() {
      return this.statusVuex[this.fieldName];
    },
    value: {
      get() {
        return this.valueVuex[this.fieldName];
      },
      set(value) {
        this.$store.dispatch('saveSendData', {
          target: this.fieldName,
          value: value
        });
      }
    },
    calcFill() {
      if (this.value !== this.item.values.trueValue.value && this.value !== this.item.values.falseValue.value) {
        return 'var(--color-gray-type2)'
      }
      return this.value === this.item.values.trueValue.value ? 'var(--color-green)':'var(--color-red-type2)';
    }
  }
}
</script>

<style scoped>

</style>